<template>
  <v-tabs
    v-model="tabModel"
    background-color="background3"
    active-class="secondaryBackground rounded-lg"
    color="primary"
    hide-slider
    class="rounded-lg d-flex segment-tab-container"
    :class="{ grow: grow, justify }"
    :height="dense ? '32px' : '40px'"
    :show-arrows="deviceSize.tablet"
  >
    <v-tab
      v-for="(tab, index) in tabs"
      :key="index"
      :href="`#${tab.value}`"
      class="segment-tab font-weight-bold"
      :class="{ 'text-body-2': !dense, 'text-caption': dense }"
      style="opacity: 1 !important"
      :style="{
        width: `${100 / tabs.length}%`,
        margin: dense ? '3px' : '4px',
        'border-radius': dense ? '5px !important' : '5px !important',
        'min-width': 'fit-content',
      }"
      :ripple="false"
    >
      <v-icon
        v-if="tab.icon"
        left
        :small="dense"
        :color="tab.iconColor || undefined"
        v-html="model === tab.value ? tab.activeIcon : tab.icon"
      />
      {{ tab.text }}
      <v-chip
        v-if="tab.chip"
        x-small
        :color="tab.chipColor || 'grey darken-1'"
        class="ml-2 px-2"
        :class="tab.chipClass"
      >
        <span class="text-caption white--text">{{ tab.chip | addComma }}</span>
      </v-chip>
    </v-tab>
  </v-tabs>
</template>

<script>
// Libraries
// Components
export default {
  name: "segmented-picker-tabs",
  props: {
    parentLoading: {
      default: false,
      type: Boolean,
      required: false,
    },
    dense: {
      default: false,
      type: Boolean,
      required: false,
    },
    grow: {
      default: false,
      type: Boolean,
      required: false,
    },
    justify: {
      default: false,
      type: Boolean,
      required: false,
    },
    model: {
      type: String,
      required: true,
    },
    tabs: {
      default: () => [
        { text: "Tab 1", value: "first" },
        { text: "Tab 2", value: "second" },
      ],
      type: Array,
      required: false,
    },
  },
  data: () => ({
    loading: false,
    value: null,
  }),
  async created() {
    await this.setup();
  },
  methods: {
    /* API Calls */
    // GET
    // POST
    /* Main */
    async setup() {},
    /* Misc */
  },
  computed: {
    tabModel: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("change", value);
      },
    },
  },
};
</script>

<style scoped>
.segment-tab::before {
  border-radius: inherit !important;
  opacity: 0 !important;
}

/* Keep tab labels on one line; narrow containers use show-arrows to scroll */
.segment-tab {
  white-space: nowrap;
}
</style>

<!-- Unscoped so grow styling works when component is rendered inside v-dialog/v-menu (portal) -->
<style>
.segment-tab-container.grow,
.segment-tab-container.grow.v-tabs {
  width: 100% !important;
}

.segment-tab-container.grow .v-tabs__bar,
.segment-tab-container.grow .v-tabs__wrapper,
.segment-tab-container.grow .v-tabs__container,
.segment-tab-container.grow .v-item-group {
  width: 100% !important;
  max-width: 100% !important;
  flex: 1 1 0 !important;
  min-width: 0 !important;
}

.segment-tab-container.grow .v-tabs__container {
  display: flex !important;
}

.segment-tab-container.grow .v-tab {
  flex: 1 1 0 !important;
  min-width: fit-content !important;
  max-width: none !important;
}
</style>
